import { render, staticRenderFns } from "./Kampagnen.vue?vue&type=template&id=54821330"
import script from "./Kampagnen.vue?vue&type=script&lang=js"
export * from "./Kampagnen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports